import { 
	makeSlave,initColorSelect, doAjax, updateTableValue, initStitchesBackgroundColorListeners, initRedPointLogic, fakeSelected, changeStitchBackgroundColor } from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initInteriorCustomizing = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions()
	const isLeatherPackage = aeo['configuration']['YS1'] === true
	const setYS1 = aeo['configuration']['YS1'] === true
	const setYZ1 = (aeo['configuration']['YZ1'] === true || aeo['configuration']['YZ1_Q7Q8'] === true || aeo['configuration']['YZ1_A8'] === true )
	const setYZ4 = aeo['configuration']['YZ4_A8'] === true
	const setQ8H7HH = aeo['configuration']['Q8H'] === true
	const setQ8H7HH_A5 = aeo['configuration']['Q8H_A5'] === true
	const setQ8H_A6etron = aeo['configuration']['Q8H_A6etron'] === true
	const setQ8H_A6_C9 = aeo['configuration']['Q8H_A6_C9'] === true
	const set7HF_A6_C9 = aeo['configuration']['7HF_A6_C9'] === true
	const set7HH_Q7Q9 = aeo['configuration']['7HH_Q7Q9'] === true
	const set7HF_Q7Q9 = aeo['configuration']['7HF_Q7Q9'] === true
	const set0UB_Q7Q9 = aeo['configuration']['0UB_Q7Q9'] === true

	const isStitchingPackage = aeo['configuration']['YVJ'] === true


	if (setYS1) {
    	//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			centerArmrest: '',
			topCenterConsole: '',
			doorTrimInsert: 'stitchDoorTrimInsert',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			doorArmRest: 'stitchDoorArmRest',
		}

		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'setYS1')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault, callback)
					var material = 'leather'
					if(stitchComponent == 'stitchDoorTrimInsert') {
						material = 'alcantara'
					}
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, material)
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
	} else if ((setYZ1) || (setYZ4)){
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			centerArmrest: 'stitchCenterArmrest',
			//doorTrimInsert: '',
			doorTrimInsert: 'stitchDoorTrimInsert',
			//$frontCenterArmrestPressedColor: 'contrastStitchingfrontCenterArmrestPressedColor',
			//$doorPanelPressedColor: '',
		}

		for (const key in interiorComponents) {
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,setImage)
					var material = 'leather'
					if(stitchComponent == 'stitchDoorTrimInsert') {
						material = 'alcantara'
					} 
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId,material)
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, setImage)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId,setImage)
			}
		}
	} else if (setQ8H7HH) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			centerArmrest: '',
			doorTrimInsert: 'stitchDoorArmRest',
			//doorArmRest: '',
			bottomCenterConsole: '',
			softwrap: 'stitchSoftwrap',
			stitchInstrumentPanelCover: ''
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'setQ8H7HH')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'dinamica')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
	} else if (setQ8H_A6etron) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			centerArmrest: '',
			doorTrimInsert: 'stitchDoorArmRest',
			//doorArmRest: '',
			bottomCenterConsole: '',
			softwrap: 'stitchSoftwrap',
			stitchInstrumentPanelCover: ''
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'setQ8H_A6etron')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'dinamica')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
	} else if (setQ8H7HH_A5) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorTrimInsert: 'stitchDoorArmRest',
			softwrap: '',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			stitchInstrumentPanelCover: '',
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'setQ8H7HH_A5')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'dinamica')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
	} else if (setQ8H_A6_C9) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorTrimInsert: 'stitchDoorArmRest',
			softwrap: '',
			//doorArmRest: 'stitchDoorArmRest',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			stitchInstrumentPanelCover: '',
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				if (setQ8H_A6_C9) {
					checkSiblings(component, colorCode, 'setQ8H_A6_C9')
				} else {
					checkSiblings(component, colorCode, 'set7HF_A6_C9')
				}
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'dinamica')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}

	} else if (set7HF_A6_C9) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorTrimInsert: 'stitchDoorArmRest',
			softwrap: '',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			instrumentPanelCover: 'stitchInstrumentPanelCover',
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'set7HF_A6_C9')
				setImage(component, colorCode)
			}

			/* get the color of instrumentPanelCover */
			const colorCode = document
 			.querySelector('#instrumentPanelCover td[color-code]')
			.getAttribute('color-code');
			const allowedColorCodes = ['5','6','8','12','36'] // available colors of the component
			/* get the color of instrumentPanelCover */
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic

				if ( // check if current color also available in InstrumentPanelCover 
					//stitchComponent === 'stitchInstrumentPanelCover' &&
					allowedColorCodes.includes(colorCode)
				) {
					if ((stitchComponent!='')) {
						const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
						makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
						initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'leather')
						initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
					}
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}

	} else if (set7HH_Q7Q9) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorArmRest: 'stitchDoorArmRest',
			centerArmrest: 'stitchCenterArmrest',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			stitchInstrumentPanelCover: '',
			rearCenterArmrestInterior: '',
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'set7HH_Q7Q9')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'dinamica')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
	} else if (set7HF_Q7Q9) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			doorArmRest: 'stitchDoorArmRest',
			centerArmrest: 'stitchCenterArmrest',
			bottomCenterConsole: 'stitchbottomCenterConsole',
			instrumentPanelCover: 'stitchInstrumentPanelCover',
			rearCenterArmrestInterior: '',
		}

		
		for (const key in interiorComponents) {
			const callback = (component, colorCode) => {
				checkSiblings(component, colorCode, 'set7HF_Q7Q9')
				setImage(component, colorCode)
			}
			
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent!='') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault ,callback)
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, 'leather')
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, callback)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, callback)
			}
		}
		
	} else if (set0UB_Q7Q9) {
		// nur ein Bauteil (doorTrimInsert), keine Kontrastnaht/Geschwister -> kein checkSiblings
		initRedPointLogic('doorTrimInsert', getDotIdWithComponent('doorTrimInsert'), setImage)
	} else if (isStitchingPackage) {
		initRedPointLogic('interiorStitch', 'dot_seat', setImage)
	}
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {
	switch (component) {
		case 'centerArmrest': return 'dot_mittelarmlehne'
		case 'rearCenterArmrestInterior': return 'dot_mittelarmlehne_hinten'		
		case 'doorTrimInsert': return 'dot_tuerverkleidung'
		case 'stitchDoorTrimInsert': return 'dot_tuer-kontrastnaht'
		case 'topCenterConsole': return 'dot_mittelkonsole-oben'
		case 'bottomCenterConsole': return 'dot_mittelkonsole-unten'
		case 'stitchbottomCenterConsole': return 'dot_mittelkonsole-unten-kontrastnaht'
		case 'doorArmRest': return 'dot_tuerarmauflage'
		case 'stitchDoorArmRest': return 'dot_tuerarmauflage-kontrastnaht'
		case 'stitchCenterArmrest': return 'dot_mittelarmlehne-kontrastnaht'
		case 'instrumentPanelCover': return 'dot_instru-abdeck'
		case 'stitchInstrumentPanelCover': return 'dot_naht-instru-abdeck'
		case 'stitchSoftwrap': return 'dot_softwrap-kontrastnaht'		
		case 'softwrap': return 'dot_softwrap'		
		default: break;
	}
}

/** Condition for makeSlave function to work */
function areMasterAndSlaveDefault(masterDotID, slaveDotID){
	let res = false;
	const masterTileSelectedValue = document.querySelector('#' + masterDotID + ' .color.selected input')?.value
	const slaveTileSelectedValue = document.querySelector('#' + slaveDotID + ' .color.selected input')?.value
	// Tiefschwarz (214) nicht auf Kontrastnaht übertragen, da nicht verfügbar
	if (masterTileSelectedValue == 214) {
		return false;
	}
	if (masterTileSelectedValue != null && masterTileSelectedValue == aeo['default_color'] && slaveTileSelectedValue == aeo['default_color']){
		res = true;
	}
	return res;
}

function setStitchColorPrimSec(component, colorCode) {
	setImage(component, colorCode) 
	fakeSelected(getDotIdWithComponent(component), colorCode)
}

function setImage(component, colorCode) {
	const n1v = document.querySelector("input[name=n1v]").value

	// set leather color to stich 
	if ((document.querySelector("input[name=carmodel]").value > 2) && (document.querySelector("input[name=carmodel]").value < 34)) {
		if(component == 'centerArmrest' 
			&& (document.querySelector('#centerArmrest td[color-code]').getAttribute('color-code') == document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code') == 99 || document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchCenterArmrest', colorCode)
		}
		if(n1v && component == 'doorTrimInsert' 
			&& (document.querySelector('#doorTrimInsert td[color-code]').getAttribute('color-code') == document.querySelector('#stitchDoorTrimInsert td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchDoorTrimInsert td[color-code]').getAttribute('color-code') == 99 || document.querySelector('#stitchDoorTrimInsert td[color-code]').getAttribute('color-code') == 199 )) {
			setStitchColorPrimSec('stitchDoorTrimInsert', colorCode)
		}
	}
	
	//if(component == centerArmrest && centerArmrest)
	let imageSourceFront;
	let imageSourceBack;
	//let isetronWheelCheck = aeo['configuration']['YSR'] == true 
	let isetronWheelCheck = aeo['configuration']['YTU'] == true 
	let isStitchingPackage = aeo['configuration']['YVJ'] == true 
	let isQ8H7HHPackage = aeo['configuration']['Q8H'] === true
	let isQ8H7HH_A5_Package = aeo['configuration']['Q8H_A5'] === true
	let isQ8H_A6etron_Package = aeo['configuration']['Q8H_A6etron'] === true
	let isQ8H_A6_C9_Package = aeo['configuration']['Q8H_A6_C9'] === true
	let is7HF_A6_C9_Package = aeo['configuration']['7HF_A6_C9'] === true
	let is7HH_Q7Q9_Package = aeo['configuration']['7HH_Q7Q9'] === true
	let is7HF_Q7Q9_Package = aeo['configuration']['7HF_Q7Q9'] === true
	let is0UB_Q7Q9_Package = aeo['configuration']['0UB_Q7Q9'] === true
	let isHourMarkSteeringWheel = aeo['configuration']['YVN'] === true || aeo['configuration']['YVN_without12h'] === true;
	var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
	const modelcategory = document.querySelector("input[name=modelcategory]").value
	// fake - doortriminsert in rhombus START
	if(component == 'doorTrimInsert' || component == 'stitchDoorTrimInsert') {
		if(modelcategory == 'a8') {
			if(n1v){
				var frontSeatModel = 'Q2J_RAUTE_AU65X'; // fake - only this seatimages has doortriminsert in rhombus
			} else {
				var frontSeatModel = 'Q2J_AU65X'; 
			}
		}
	}
	// fake - doortriminsert in rhombus END

	// fake YVN_without12h to YVN when back button is clicked
	if (isHourMarkSteeringWheel) {
		doAjax({
			'package_selection_option': 'YVN_without12h',
			'checked': false
		});
		doAjax({
			'package_selection_option': 'YVN',
			'checked': true
		});
	}


	if (isStitchingPackage){
		imageSourceFront = aeo['images'][isHourMarkSteeringWheel ? 'twelve_mark_interior_stitch_front' : 'interior_stitch_front'][colorCode]
		imageSourceBack = aeo['images']['interior_stitch_back'][colorCode]
		var imageSourceEmbossing = aeo['images']['footmatEmbossing_YTU_front_view'][colorCode]
		var componentEmboss = "footmatEmbossing";
		if(modelcategory == 'e-tron_gt') {
			if (isetronWheelCheck) replaceImage(imageSourceEmbossing, componentEmboss+'Color', 'car_frontseat')
		}
	} else if (isQ8H7HHPackage) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_'+component+'_front_view'][colorCode]
		if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert')) {
			imageSourceBack = aeo['images']['car_backseat_'+frontSeatModel+'_'+backSeatModel+'_Q8H_7HH_'+component+'_back_view'][colorCode]
		}
	} else if (isQ8H_A6etron_Package) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_'+component+'_front_view'][colorCode]
		if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert')) {
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_'+component+'_back_view'][colorCode]
		}
	} else if (isQ8H7HH_A5_Package) {
		if ((document.querySelector("input[name=carmodel]").value == 46) || (document.querySelector("input[name=carmodel]").value == 47)) {	
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_RS5_'+component+'_front_view'][colorCode]
			if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'stitchInstrumentPanelCover')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_RS5_'+component+'_back_view'][colorCode]
			}
		} else {
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_A5_'+component+'_front_view'][colorCode]
			if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'stitchInstrumentPanelCover')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_A5_'+component+'_back_view'][colorCode]
			}
		}
	} else if (isQ8H_A6_C9_Package) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_A6_C9_'+component+'_front_view'][colorCode]
		if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'stitchInstrumentPanelCover') || (component == 'doorArmRest') || (component == 'softwrap')) {
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_A6_C9_'+component+'_back_view'][colorCode]
		}
	} else if (is7HF_A6_C9_Package) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HF_A6_C9_'+component+'_front_view'][colorCode]
		if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'instrumentPanelCover') || (component == 'stitchInstrumentPanelCover') || (component == 'doorArmRest') || (component == 'softwrap')) {
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_A6_C9_'+component+'_back_view'][colorCode]
		}
	
	} else if (is7HH_Q7Q9_Package) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HH_Q7Q9_'+component+'_front_view'][colorCode]		
		if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'rearCenterArmrestInterior') || (component == 'stitchInstrumentPanelCover') || (component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole')) {
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HH_Q7Q9_'+component+'_back_view'][colorCode]
		}
		if ((document.querySelector("input[name=carmodel]").value == 118) || (document.querySelector("input[name=carmodel]").value == 119) || (document.querySelector("input[name=carmodel]").value == 120)) {	
			if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'rearCenterArmrestInterior') || (component == 'stitchInstrumentPanelCover') || (component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HH_Q9_'+component+'_back_view'][colorCode]
			}
		}
	} else if (is7HF_Q7Q9_Package) {
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HF_Q7Q9_'+component+'_front_view'][colorCode]
		if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'rearCenterArmrestInterior') || (component == 'stitchInstrumentPanelCover') || (component == 'instrumentPanelCover') || (component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole')) {
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_Q7Q9_'+component+'_back_view'][colorCode]
		}
		if ((document.querySelector("input[name=carmodel]").value == 118) || (document.querySelector("input[name=carmodel]").value == 119) || (document.querySelector("input[name=carmodel]").value == 120)) {	
			if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'rearCenterArmrestInterior') || (component == 'stitchInstrumentPanelCover') || (component == 'instrumentPanelCover') || (component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_Q9_'+component+'_back_view'][colorCode]
			}
		}
	} else if (is0UB_Q7Q9_Package) {
		// 0UB_Q7Q9: nur doorTrimInsert (vorne + hinten)
		imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_0UB_Q7Q9_'+component+'_front_view'][colorCode]
		imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_0UB_Q7Q9_'+component+'_back_view'][colorCode]
		if ((document.querySelector("input[name=carmodel]").value == 118) || (document.querySelector("input[name=carmodel]").value == 119) || (document.querySelector("input[name=carmodel]").value == 120)) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_0UB_Q9_'+component+'_back_view'][colorCode]
			}
	} else {
		imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
		imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]
	}
	//replace image on front and back 
	
	

	replaceImage(imageSourceFront, component+'Color', 'car_frontseat')
	switch(modelcategory) {
		case 'e-tron_gt': 
		if (component != 'topCenterConsole') {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		break; 
		default: 
		if ((component == 'doorTrimInsert') || (component == 'doorArmRest') || (component == 'stitchDoorArmRest')) {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		if (((component == 'doorTrimInsert') || (component == 'doorArmRest') || (component == 'stitchDoorArmRest') || (component == 'stitchInstrumentPanelCover')) && (modelcategory == 'a5')) {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		if (((component == 'doorTrimInsert') || (component == 'doorArmRest') || (component == 'stitchDoorArmRest') || (component == 'instrumentPanelCover') || (component == 'stitchInstrumentPanelCover') || (component == 'softwrap')) && (modelcategory == 'a6_c9')) {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		if (((component != 'centerArmrest')  ||  (component != 'stitchCenterArmrest')) && (modelcategory == 'a8')) {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
		
		if (((component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole') || (component == 'stitchDoorArmRest') || (component == 'stitchInstrumentPanelCover') || (component == 'instrumentPanelCover') || (component == 'rearCenterArmrestInterior')) && (modelcategory == 'q7_g8' || modelcategory == 'q9_g8')) {
			replaceImage(imageSourceBack, component+'Color', 'car_backseat')
		}
	}
	

	//If Stitch Package
	if (isStitchingPackage && component == "interiorStitch"){
		//update footmats
		['stitchPiping'].forEach(componentName => {
			doAjax({
				'interior_component': componentName,
				'color': colorCode,
				'src': ''
			})
		});
		//update steering wheel
		['stitches', 'hourMark', 'stitchHourMark', 'GearLeverStitches','AirbagCoverLeather','AirbagCoverStitches'].forEach(componentName => {
			let tmpcolorCode = colorCode
			if (
				componentName == 'hourMark' &&
				(
					colorCode == 9 ||
					colorCode == 11 ||
					plusColors.includes(Number(colorCode))
				)
			) {
				tmpcolorCode = 0;
			}
			doAjax({
				'steering_wheel_component': componentName,
				'color': tmpcolorCode,
				'src': ''
			})
		});

		// update footmat embossing
		doAjax({
			'interior_component': "footmatEmbossing",
			'color': colorCode,
			'src': imageSourceFront
		});

		//update seat component
		doAjax({
			'individual-frontseat' : true,
			'seat-color': 8,
			'seat-stitch': colorCode,
			'biese-color': 8,
			'embossing-color': 8
		}, (response) => {
		})
	}

	updateTableValue(component, colorCode,'interior-components')
	doAjax({
		'interior_component' : component,
		'color' : colorCode,
		'src': imageSourceFront
	})
}


function checkSiblings(component, colorCode , packageType) {
	let stitchComponents
	let leatherComponents
	if(packageType == 'setYS1') {
        stitchComponents = ['stitchDoorTrimInsert', 'stitchbottomCenterConsole', 'stitchDoorArmRest']
		leatherComponents = ['centerArmrest', 'topCenterConsole', 'doorTrimInsert', 'bottomCenterConsole', 'doorArmRest']
	} else if(packageType == 'setQ8H7HH_A5') {
		stitchComponents = ['stitchDoorArmRest', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole']
	} else if(packageType == 'setQ8H_A6_C9') {
		stitchComponents = ['stitchDoorArmRest', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole']
	} else if (packageType == 'set7HF_A6_C9') {
		stitchComponents = ['stitchDoorArmRest', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole','doorArmRest', 'instrumentPanelCover']
	} else if(packageType == 'setQ8H_A6etron') {
		stitchComponents = ['stitchDoorArmRest', 'stitchSoftwrap', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole','centerArmrest']
	} else if(packageType == 'setQ8H7HH') {
		stitchComponents = ['stitchDoorArmRest', 'stitchSoftwrap', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole','centerArmrest']
	} else if(packageType == 'set7HH_Q7Q9') {
		stitchComponents = ['stitchDoorArmRest', 'stitchbottomCenterConsole', 'stitchCenterArmrest', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorArmRest', 'bottomCenterConsole','centerArmrest', 'rearCenterArmrestInterior']
	} else if(packageType == 'set7HF_Q7Q9') {
		stitchComponents = ['stitchDoorArmRest', 'stitchbottomCenterConsole', 'stitchCenterArmrest', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorArmRest', 'bottomCenterConsole','centerArmrest', 'instrumentPanelCover', 'rearCenterArmrestInterior']
	} else {
		stitchComponents = ['stitchDoorArmRest', 'stitchSoftwrap', 'stitchInstrumentPanelCover']
		leatherComponents = ['doorTrimInsert', 'softwrap', 'bottomCenterConsole','centerArmrest']
	}
	const isStitchElement = stitchComponents.indexOf(component) != -1
	if (areAllLeatherComponentsTheSameColor() && areAllStitchesComponentsTheSameColor()) {
		if (areAllLeatherComponentsDefaultColor() == true) {
			if (areAllStitchesComponentsDefaultColor() == true) {
				if (isStitchElement) {
					changeComponents(stitchComponents, colorCode, packageType)
				} else {
					changeComponents(leatherComponents, colorCode, packageType)
					// Tiefschwarz (214) nicht auf Kontrastnähte übertragen, da nicht verfügbar
					if (colorCode == 214) {
						return;
					}
					changeComponents(stitchComponents, colorCode, packageType)
					if(packageType == 'setYS1') {
						changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorTrimInsert'), colorCode, 'alcantara')
						changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorArmRest'), colorCode, 'leather')
						changeStitchBackgroundColor(getDotIdWithComponent('stitchbottomCenterConsole'), colorCode, 'leather')
					} else if (packageType == 'setQ8H7HH_A5') {
						changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorArmRest'), colorCode, 'dinamica')
						changeStitchBackgroundColor(getDotIdWithComponent('stitchbottomCenterConsole'), colorCode, 'leather')
					} else {
						changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorArmRest'), colorCode, 'dinamica')
					}
					if(colorCode != 2) {
						changeStitchBackgroundColor(getDotIdWithComponent('stitchSoftwrap'), colorCode, 'dinamica')
					}
				}
			} else if (areAllStitchesComponentsDefaultColor() == false && isStitchElement == false) {
				changeComponents(leatherComponents, colorCode, packageType)

				if(packageType == 'setYS1') {
					changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorTrimInsert'), colorCode, 'alcantara')
					changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorArmRest'), colorCode, 'leather')
					changeStitchBackgroundColor(getDotIdWithComponent('stitchbottomCenterConsole'), colorCode, 'leather')
				} else {
					changeStitchBackgroundColor(getDotIdWithComponent('stitchDoorArmRest'), colorCode, 'dinamica')
				}
				if(colorCode != 2) {
					changeStitchBackgroundColor(getDotIdWithComponent('stitchSoftwrap'), colorCode, 'dinamica')
				}
			}
		} else if (areAllLeatherComponentsDefaultColor() == false) {
			let selectedColor1
			let selectedStitchColor1

			if (packageType == 'set7HH_Q7Q9' || packageType == 'set7HF_Q7Q9') {
				selectedColor1 = document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code')
				selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
			} else {
				selectedColor1 = document.querySelector('#doorTrimInsert td[color-code]').getAttribute('color-code')
				selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
			}
			if (isStitchElement && selectedColor1 == selectedStitchColor1) {
				changeComponents(stitchComponents, colorCode, packageType)
			}
		}
	}
}

/** This method will fake select the tile and change the components color for the components passed as parameter */
function changeComponents(components, colorCode, packageType) {
	components.forEach(component => {
		// Prüfe ob die Farbe für dieses Bauteil verfügbar ist (Farbkachel im DOM vorhanden)
		const dotId = getDotIdWithComponent(component)
		if (dotId && !document.querySelector('#' + dotId + ' .color input[value="' + colorCode + '"]')) {
			return // Farbe nicht verfügbar für dieses Bauteil - überspringen
		}
		if ((packageType == 'setQ8H_A6_C9') || (packageType == 'set7HF_A6_C9')) {
			setImage(component, colorCode)
			fakeSelected(dotId, colorCode)
		} else {
			//if(!(packageType == 'setQ8H_A6etron' && component == 'softwrap' && colorCode == 2)) { // no diamantsilever (colorcode 2) in softwrap
			if(!(packageType == 'setQ8H_A6etron' && component == 'softwrap' && colorCode == 29999)) { // no diamantsilever (colorcode 2) in softwrap
				setImage(component, colorCode)
				fakeSelected(dotId, colorCode)
			}
		}
	});
}

function areAllLeatherComponentsTheSameColor() {
	const setYS1 = aeo['configuration']['YS1'] === true
	const set7HH_Q7Q9 = aeo['configuration']['7HH_Q7Q9'] === true
	const set7HF_Q7Q9 = aeo['configuration']['7HF_Q7Q9'] === true
	
	if(setYS1) { 
		const selectedColor1 = document.querySelector('#centerArmrest td[color-code]').getAttribute('color-code')
		const selectedColor2 = document.querySelector('#topCenterConsole td[color-code]').getAttribute('color-code')
		const selectedColor3 = document.querySelector('#doorTrimInsert td[color-code]').getAttribute('color-code')
		const selectedColor4 = document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code')
		const selectedColor5 = document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code')
		return selectedColor1 == selectedColor2 && selectedColor2 == selectedColor3 && selectedColor3 == selectedColor4 && selectedColor4 == selectedColor5
	} else if (set7HH_Q7Q9) {
		const selectedColor1 = document.querySelector('#centerArmrest td[color-code]').getAttribute('color-code')
		const selectedColor2 = document.querySelector('#rearCenterArmrestInterior td[color-code]').getAttribute('color-code')
		const selectedColor3 = document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code')
		const selectedColor4 = document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code')
		return selectedColor1 == selectedColor2 && selectedColor2 == selectedColor3 && selectedColor3 == selectedColor4		
	} else if (set7HF_Q7Q9) {
		const selectedColor1 = document.querySelector('#centerArmrest td[color-code]').getAttribute('color-code')
		const selectedColor2 = document.querySelector('#rearCenterArmrestInterior td[color-code]').getAttribute('color-code')
		const selectedColor3 = document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code')
		const selectedColor4 = document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code')
		const selectedColor5 = document.querySelector('#instrumentPanelCover td[color-code]').getAttribute('color-code')
		return selectedColor1 == selectedColor2 && selectedColor2 == selectedColor3 && selectedColor3 == selectedColor4	 && selectedColor4 == selectedColor5		
	} else {
		const selectedColor1 = document.querySelector('#doorTrimInsert td[color-code]').getAttribute('color-code')
		const selectedColor2 = document.querySelector('#softwrap td[color-code]').getAttribute('color-code')
		const selectedColor3 = document.querySelector('#bottomCenterConsole td[color-code]').getAttribute('color-code')
		return selectedColor1 == selectedColor2 && selectedColor2 == selectedColor3
	}
}

function areAllLeatherComponentsDefaultColor() {
	const set7HH_Q7Q9 = aeo['configuration']['7HH_Q7Q9'] === true
	const set7HF_Q7Q9 = aeo['configuration']['7HF_Q7Q9'] === true
	let selectedColor1

	if (set7HH_Q7Q9 || set7HF_Q7Q9) {
		selectedColor1 = document.querySelector('#doorArmRest td[color-code]').getAttribute('color-code')
	} else {
		selectedColor1 = document.querySelector('#doorTrimInsert td[color-code]').getAttribute('color-code')
	}
	const firstComponentIsDefaultColor = selectedColor1 == aeo['default_color'].toString()
	return areAllLeatherComponentsTheSameColor() && firstComponentIsDefaultColor
}

function areAllStitchesComponentsTheSameColor() {
	const setYS1 = aeo['configuration']['YS1'] === true
	const setQ8H7HH_A5 = aeo['configuration']['Q8H_A5'] === true
	const setQ8H_A6_C9 = aeo['configuration']['Q8H_A6_C9'] === true
	const set7HF_A6_C9 = aeo['configuration']['7HF_A6_C9'] === true
	const set7HH_Q7Q9 = aeo['configuration']['7HH_Q7Q9'] === true
	const set7HF_Q7Q9 = aeo['configuration']['7HF_Q7Q9'] === true
	let selectedStitchColor1, selectedStitchColor2, selectedStitchColor3;
	if(setQ8H7HH_A5) {
		selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
	} else if(setQ8H_A6_C9) {
		selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
	} else if(set7HF_A6_C9) {
		selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
	} else if(setYS1) {
		selectedStitchColor1 = document.querySelector('#stitchDoorTrimInsert td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
	} else if(set7HH_Q7Q9) {
		selectedStitchColor1 = document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
	} else if(set7HF_Q7Q9) {
		selectedStitchColor1 = document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchbottomCenterConsole td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
	} else {
		selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
		selectedStitchColor2 = document.querySelector('#stitchInstrumentPanelCover td[color-code]').getAttribute('color-code')
		selectedStitchColor3 = document.querySelector('#stitchSoftwrap td[color-code]').getAttribute('color-code')
	}
	return selectedStitchColor1 == selectedStitchColor2 && selectedStitchColor2 == selectedStitchColor3
}

function areAllStitchesComponentsDefaultColor() {
    const setYS1 = aeo['configuration']['YS1'] === true
    const selectedStitchColor1 = document.querySelector('#stitchDoorArmRest td[color-code]').getAttribute('color-code')
    let firstStitchComponentIsDefaultColor = false;  // <-- HIER: let ergänzen
    if(setYS1) {
        firstStitchComponentIsDefaultColor = selectedStitchColor1 == '8' // 9 = default stitches = schwarz
    } else {
        firstStitchComponentIsDefaultColor = selectedStitchColor1 == '199' // 199 = default stitches = steelgrey
    }
    return areAllStitchesComponentsTheSameColor() && firstStitchComponentIsDefaultColor
}

export { initInteriorCustomizing };